import { render, staticRenderFns } from "./clubcard.vue?vue&type=template&id=3c80ef31&scoped=true"
import script from "./clubcard.vue?vue&type=script&lang=js"
export * from "./clubcard.vue?vue&type=script&lang=js"
import style0 from "./clubcard.vue?vue&type=style&index=0&id=3c80ef31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c80ef31",
  null
  
)

export default component.exports